import { Chip, MenuItem, Select } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";

const AutoAssignCell = ({ params, onAutoAssignClick }) => {
  const isAutoAssigned = params.row.is_auto_assigned === 1;
  
  return (
    <Select
      value={isAutoAssigned ? 1 : 0}
      renderValue={(value) => (
        <Chip
          icon={value === 1 ? <CheckCircleIcon /> : <CancelIcon />}
          label={value === 1 ? "Yes" : "No"}
          color={value === 1 ? "success" : "default"}
          variant="outlined"
        />
      )}
      label="Auto Assigned"
      onChange={() => onAutoAssignClick(params.row)}
      sx={{
        height: "100%",
        minHeight: "52px",
        border: "none",
        "& .MuiOutlinedInput-notchedOutline": { border: "none" },
        "&:hover .MuiOutlinedInput-notchedOutline": { border: "none" },
        "&.Mui-focused .MuiOutlinedInput-notchedOutline": { border: "none" },
      }}
    >
      <MenuItem value={1}>
        <Chip label="Yes" color="success" />
      </MenuItem>
      <MenuItem value={0}>
        <Chip label="No" color="default" />
      </MenuItem>
    </Select>
  );
};

export default AutoAssignCell;